/**
 * @module services/appointment-status
 * @description Etiqueta y color del estado de un turno para Agenda
 *              (Calendario), "Cita asignada" y Atenciones. UC-REG-273.
 *              Estados del API (`Appointment.status`): pending, admitted,
 *              started, done, cancelled. "Ausente" no existe en el API: es un
 *              turno pendiente cuyo horario ya terminó (se calcula, no se
 *              graba).
 */

/** @description Etiqueta y clase CSS por estado. */
export const APPOINTMENT_STATUS = {
  pending: { label: "Pendiente", className: "appt-status--pending" },
  absent: { label: "Ausente", className: "appt-status--absent" },
  admitted: { label: "En sala", className: "appt-status--admitted" },
  started: { label: "En curso", className: "appt-status--started" },
  done: { label: "Atención finalizada", className: "appt-status--done" },
  cancelled: { label: "Cancelado", className: "appt-status--cancelled" },
};

/**
 * @description Estado a mostrar para una cita.
 * @param {Object|null} appointment - Cita (status, endsAt)
 * @param {Date} [now] - Momento de referencia (default: ahora)
 * @returns {{key: string, label: string, className: string}|null}
 */
export function getAppointmentStatus(appointment, now = new Date()) {
  if (!appointment) return null;
  let key = APPOINTMENT_STATUS[appointment.status]
    ? appointment.status
    : "pending";
  if (
    key === "pending" &&
    appointment.endsAt &&
    new Date(appointment.endsAt) < now
  ) {
    key = "absent";
  }
  return { key, ...APPOINTMENT_STATUS[key] };
}
